export default __webpack_public_path__ + "static/media/Hawk.cf307393.png";